import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, } from "react";
import { cn } from "./utils.js";
const sizes = {
    lg: "max-w-2xl",
    md: "max-w-lg",
    sm: "max-w-sm",
};
const FIELD_SELECTOR = "input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled])";
export function Dialog({ children, description, eyebrow, footer, onClose, open, size = "md", title, }) {
    const ref = useRef(null);
    const opener = useRef(null);
    const titleId = useId();
    const descriptionId = useId();
    useEffect(() => {
        const dialog = ref.current;
        if (!dialog)
            return;
        if (open && !dialog.open) {
            opener.current =
                document.activeElement instanceof HTMLElement
                    ? document.activeElement
                    : null;
            dialog.showModal();
            const target = dialog.querySelector("[autofocus]") ??
                dialog.querySelector(FIELD_SELECTOR);
            target?.focus();
        }
        else if (!open && dialog.open) {
            dialog.close();
            opener.current?.focus();
            opener.current = null;
        }
    }, [open]);
    useEffect(() => () => {
        opener.current?.focus();
    }, []);
    function handleCancel(event) {
        event.preventDefault();
        onClose();
    }
    function handleBackdropClick(event) {
        if (event.target === event.currentTarget)
            onClose();
    }
    return (_jsx("dialog", { "aria-describedby": open && description ? descriptionId : undefined, "aria-labelledby": open ? titleId : undefined, className: cn("m-auto max-h-[calc(100dvh-2rem)] w-[calc(100%-2rem)] overflow-y-auto rounded-xl border border-stone-200 bg-surface p-0 text-stone-950 shadow-2xl backdrop:bg-stone-950/45", sizes[size]), onCancel: handleCancel, onClick: handleBackdropClick, ref: ref, children: open ? (_jsxs("div", { className: "p-5 sm:p-6", children: [_jsxs("header", { className: "space-y-1.5", children: [eyebrow ? (_jsx("p", { className: "text-xs font-semibold tracking-widest text-stone-500 uppercase", children: eyebrow })) : null, _jsx("h2", { className: "text-lg font-bold tracking-[-0.015em]", id: titleId, children: title }), description ? (_jsx("p", { className: "text-sm text-stone-500", id: descriptionId, children: description })) : null] }), _jsx("div", { className: "mt-5", children: children }), footer ? (_jsx("footer", { className: "mt-6 flex flex-wrap justify-end gap-3", children: footer })) : null] })) : null }));
}
